


































































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { required, email } from 'vuelidate/lib/validators';
import RecaptchaComponent from '@/shared/captchaComponent/RecaptchaComponent.vue';
import { SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { InfoState } from '../core.store';
@Component({
  components: {
    ...UUIFComponent,
    RecaptchaComponent,
    SwTextarea,
  },
  validations: {
    replyTo: { required, email },
    subject: { required },
    desc: { required },
  },
})
export default class FeedbackDialog extends SwExtendedVue {
  @Prop()
  showFeedBackDialog: boolean;
  submitted: boolean = false;
  replyTo: string = '';
  subject: string = '';
  desc: string = '';
  captchaError: string = '';
  created() {
    setTimeout(() => {
      const wrapper2 = document.getElementById('replyToForFeedback') as HTMLElement;
      if (wrapper2) {
        wrapper2.children[0]
          .getElementsByTagName('input')[0]
          .focus();
      }
    },         200);
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
  resetForm() {
    this.$v.$reset();
    this.replyTo = this.subject = this.desc = '';
    this.submitted = false;
    this.captchaError = '';
  }
  send (captchaText: string) {
    const request = {
      captchaText,
      emailAddress: this.replyTo,
      subject: this.subject,
      comments: this.desc,
      screen: this.$router.currentRoute.path,
    };
    this.$store.dispatch('sendFeedback', request)
      .then((res: any) => {
        if (res.msgCode === 'MSWAPP:SUCCESS') {
          const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
          this.closeDialog();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: res.msgDesc };
          this.$store.commit('enqueueMessage', message);
        }
      })
      .finally(() => {
        this.$store.commit('stopLoading');
      });
  }
  validateForm() {
    this.submitted = true;
    this.$v.$touch();
    if (this.$v.$invalid) {
      return;
    }
    const captcha = (this.$refs.recaptcha as any).fetchCaptcha();
    if (captcha.status === 'error') {
      this.captchaError = captcha.msg;
      return;
    }
    this.captchaError = '';
    this.send(captcha.response);
  }
}
